import { useEffect, useRef, useState } from "react";
import { renderAsync } from "docx-preview";
import { fetchFileToFileAndBlob } from "@lhd/utility";

export interface IProps {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  uri?: string;
}

const useText = (props: IProps) => {
  const { uri, setLoading } = props;
  const [text, setText] = useState<string>("");
  const handleLoadText = async () => {
    if (!uri) {
      setLoading(false);
      return;
    }
    const [file] = await fetchFileToFileAndBlob(uri);
    const reader = new FileReader();
    reader.onload = () => {
      setText(reader.result as string);
    };
    reader.readAsText(file);

    setLoading(false);
  };
  useEffect(() => {
    uri && handleLoadText();
  }, [uri]);
  return {
    ...props,
    text,
  };
};

export type Props = ReturnType<typeof useText>;

export default useText;
